//---------------------------------------------------------------------
//|              ***  DEVELOPMENT CPA Education ENVIRONMENT SETTINGS        ***     |
//---------------------------------------------------------------------

export const environment = {
  production: false,
  appVersion: 'v2.0',
  USERDATA_KEY: 'authf649fc9a5f55',
  isMockEnabled: false,
  baseUrl: 'https://dev-cpa-app.azurewebsites.net',
  appUrl: 'https://dev.cpa.education',
  website: 'cpa.education',
  fileFetchUrl: 'https://dev.cpa.education/fetchUrl',
  userType: 'CB',
  securityCodeForInstitution: 'HT2003APR29M',
  subDomain: 'dev',
  stripe: 'pk_test_h3h2zkeiGEepgCIOV4neebUL0013Qd9Rw3',
  reCaptcha_SiteKey: '6Lfa1_AZAAAAAKcRDyRDIVJCW5sXeOPV15Pgi4KW',
  reCaptcha: '6Lfa1_AZAAAAAMRfgwp-ef3fs68l_8GQ26kg6J8o',
  tokenUrl: null as any, // For IdentityServer/Authorization Server API. You can set to null if same as baseUrl
  loginUrl: '/auth/login',
  cashfreeConfig: 'sandbox',
  stripeInstantWalletLookup: 'test_instant_recharge',
  stripeMonthlyWalletLookup: 'test_monthly_recharge',
  azureSignalRbaseUrl: 'https://a8que.service.signalr.net/',
  securityKey: '7061737323313233',
  appThemeName: 'CPA Education',
};

if (window.location.hostname.includes('dev')) {
  environment.subDomain = 'dev';
  environment.appUrl = 'https://dev.cpa.education';
}





//---------------------------------------------------------------------
//|              ***  PRODUCTION ENVIRONMENT SETTINGS        ***      |
//---------------------------------------------------------------------

// Uncomment from below line of code only


// export const environment = {
//   production: false,
//   appVersion: 'v2.0',
//   USERDATA_KEY: 'authf649fc9a5f55',
//   isMockEnabled: false,
//   baseUrl: 'https://cpaprodapi.azurewebsites.net',
//   appUrl: 'https://my.cpa.education',
//   website: 'cpa.education',
//   fileFetchUrl: 'https://my.cpa.education/fetchUrl',
//   userType: 'CB',
//   securityCodeForInstitution: 'HT2003APR29M',
//   subDomain: 'my',
//   stripe: 'pk_live_51RJvpZPBYs1OOXFDJWUfFl6bvdJMiNKROLac8ZzcR5N1QkuvWwmqDnFnzOIfD6dvpoCHgOU2SyctKvZ3BNLTQqjC00A3q7F21S',
//   reCaptcha_SiteKey: '6Lfa1_AZAAAAAKcRDyRDIVJCW5sXeOPV15Pgi4KW',
//   reCaptcha: '6Lfa1_AZAAAAAMRfgwp-ef3fs68l_8GQ26kg6J8o',
//   tokenUrl: null as any, // For IdentityServer/Authorization Server API. You can set to null if same as baseUrl
//   loginUrl: '/auth/login',
//   cashfreeConfig: 'sandbox',
//   stripeInstantWalletLookup: 'prod_instant_recharge',
//   stripeMonthlyWalletLookup: 'prod_monthly_recharge',
//   azureSignalRbaseUrl: 'https://a8que.service.signalr.net/',
//   securityKey : '7061737323313233',
//   appThemeName: 'CPA Education',
// };

// if (window.location.hostname.includes('test')) {
//   // environment.userType = 'CB';
//   environment.subDomain = 'test';
//   environment.appUrl = 'https://test.cpa.education';
// }
// else if (window.location.hostname.includes('my')) {
//   // environment.userType = 'CB';
//   environment.subDomain = 'my';
//   environment.appUrl = 'https://my.cpa.education';
// }
